<template>
  <a v-on="$listeners" class="diy-topbar__menu-item" :target="isLink && '_blank'">
    <AppIcon :icon="icon" />
    <span class="diy-topbar__menu-item-text">
      <slot />
      <AppIcon v-if="submenu" icon="fal fa-chevron-right" />
    </span>
    <slot name="append-content" />
  </a>
</template>

<script>
// Components
import AppIcon from 'Ui/AppIcon'

export default {
  name: 'TheTopbarNavbarItem',

  components: {
    AppIcon,
  },

  props: {
    icon: {
      type: String,
      default: '',
    },

    submenu: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    isLink() {
      return this.$attrs.href
    },
  },
}
</script>

<style scoped>
.diy-topbar__menu-item {
  text-decoration: none;
}

.diy-topbar__menu-item-text {
  width: 100%;
  height: 100%;
}

.diy-topbar__menu-item-text >>> .app-link,
.diy-topbar__menu-item-text >>> .app-link__text {
  padding: 0;
  margin: 0;
}
</style>

<style scoped src="@/assets/css/shared-styles/topbar-navbar.css"></style>
